import { render, staticRenderFns } from "./PaymentInfoSetting.vue?vue&type=template&id=0db2d45b&scoped=true"
import script from "./PaymentInfoSetting.vue?vue&type=script&lang=js"
export * from "./PaymentInfoSetting.vue?vue&type=script&lang=js"
import style0 from "./PaymentInfoSetting.vue?vue&type=style&index=0&id=0db2d45b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db2d45b",
  null
  
)

export default component.exports